import { FC, PropsWithChildren } from 'react';

interface DrawerFooterProps {
  className?: string;
}

export const DrawerFooter: FC<PropsWithChildren<DrawerFooterProps>> = ({
  children,
  className,
}) => {
  return (
    <div slot="footer" className={className}>
      {children}
    </div>
  );
};
